export default "__VITE_ASSET__CSTWmZGj__"